module.exports = __webpack_public_path__ + "img/tongguo_img.00b039c8.png";